import { differenceInHours, differenceInDays } from "date-fns";
import { FormattedMessage } from "react-intl";

export const timeSincePublication = (publicationDate, lang) => {
  const publicationUtcDate = new Date(
    publicationDate.slice(0, 23) + "Z"
  ).toISOString();

  const hoursDifference = differenceInHours(
    new Date(),
    new Date(publicationUtcDate)
  );
  const daysDifference = differenceInDays(
    new Date(),
    new Date(publicationUtcDate)
  );
  const dayTransl = lang === "fr" ? "j" : "d";
  return hoursDifference < 24
    ? `${hoursDifference}h`
    : `${daysDifference}${dayTransl}`;
};

export const linkWording = ({ entity, text }) => {
  let messageId = "";
  if (entity === "missions") {
    messageId = "see_the_mission";
  } else {
    messageId = "see_the_profil_of";
  }
  return (
    <span>
      <FormattedMessage
        id={messageId}
        defaultMessage={
          entity === "missions" ? "Voir la mission" : "Voir le profil de"
        }
      />{" "}
      {text}
    </span>
  );
};

export const toggleNotificationId = (
  notificationId,
  setCheckedNotificationsIds
) => {
  setCheckedNotificationsIds((prev = []) =>
    prev.includes(notificationId)
      ? prev.filter((e) => e !== notificationId)
      : [...prev, notificationId]
  );
};

export const handleToggleSection = ({
  isArchivedSectionAsked,
  setNotifications,
  setCheckedNotificationsIds,
  setSelectedNotification,
  setIsSelectAllNotificationsChecked,
  setIsArchivedSection,
}) => {
  setNotifications({});
  setCheckedNotificationsIds([]);
  setSelectedNotification({});
  setIsSelectAllNotificationsChecked(false);
  setIsArchivedSection(isArchivedSectionAsked);
};

export const handleBulkAction = (
  type,
  {
    isSelectAllNotificationsChecked,
    checkedNotificationsIds,
    isArchivedSection,
    notificationsContent,
    selectedNotification,
    setSelectedNotification,
    setIsNotificationDetail,
    setIsSelectAllNotificationsChecked,
    setNotifications,
    deleteNotifications,
    updateNotifications,
  }
) => {
  const isDelete = type === "delete";
  const actionType = isDelete ? deleteNotifications : updateNotifications;

  const payload = (ids, all) => ({
    data: {
      alerts_ids: ids,
      all,
      ...(isDelete ? { is_archived: isArchivedSection } : { archive: true }),
    },
  });

  const clearSelection = () => {
    setSelectedNotification({});
    setIsNotificationDetail(false);
  };

  const updateSelectedNotifications = (ids) => {
    ids.forEach((id) => {
      const notif = notificationsContent.find((e) => e?.alert_id === id);
      if (!notif) return;

      isDelete ? (notif.deleted = true) : (notif.archived = true);

      selectedNotification?.alert_id === id && clearSelection();
    });
  };

  if (isSelectAllNotificationsChecked) {
    actionType(payload([], true));
    clearSelection();
    setIsSelectAllNotificationsChecked(false);
    setNotifications([]);
    return;
  }

  if (checkedNotificationsIds?.length > 0) {
    actionType(payload(checkedNotificationsIds, false));
    updateSelectedNotifications(checkedNotificationsIds);
  }
};

export const handleDelete = (
  id,
  deleteNotifications,
  isArchivedSection,
  notificationsContent,
  setSelectedNotification,
  setIsNotificationDetail
) => {
  deleteNotifications({
    data: {
      alerts_ids: [id],
      is_archived: isArchivedSection,
      all: false,
    },
  });

  const notif = notificationsContent.find((e) => e?.alert_id === id);
  if (notif) notif.deleted = true;

  setSelectedNotification({});
  setIsNotificationDetail(false);
};

export const handleArchive = (
  selectedNotificationId,
  notificationsContent,
  updateNotifications,
  setSelectedNotification,
  setIsNotificationDetail
) => {
  const notif = notificationsContent.find(
    (e) => e?.alert_id === selectedNotificationId
  );
  if (!notif?.archive) {
    updateNotifications({
      data: {
        alerts_ids: [selectedNotificationId],
        archive: true,
        all: false,
      },
    });
    notif.archived = true;
  }

  setSelectedNotification({});
  setIsNotificationDetail(false);
};
